<div class="private-access">

  <mat-icon svgIcon="lock" class="lock-icon"></mat-icon>

  <main>
    <h2>{{'signin.title' | translate}}</h2>
    <div class="text-content" [innerHTML]="'signin.introText01' | translate"></div>

    <div class="text-content" [innerHTML]="textLink" (click)="link();"></div>
    <!-- <div *ngIf="typeLink === URLS_TYPES_PRODUCTS || typeLink === URLS_TYPES_COURSES"
      [routerLink]="('/usuarios/registro?returnUrl=' + returnURL)" class="text-content" [innerHTML]="textLink"></div>
    <div *ngIf="typeLink === URLS_TYPES_CONTACTS" [routerLink]="'/informacion/suscripciones'" class="text-content"
      [innerHTML]="textLink"></div> -->

    <div class="text-content" [innerHTML]="'general.phoneContact' | translate"></div>

    <form [formGroup]="form" (submit)="login();">

      <div class="login-box">

        <mat-form-field>
          <span matPrefix>
            <mat-icon svgIcon="user"></mat-icon>
          </span>
          <!-- <mat-label>{{'core.signin.username' | translate}}</mat-label> -->
          <input matInput placeholder="{{'core.signin.username' | translate}}" formControlName="username" required>
          <mat-error>{{'general.required' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <span matPrefix>
            <mat-icon svgIcon="lock"></mat-icon>
          </span>
          <!-- <mat-label>{{'core.signin.password' | translate}}</mat-label> -->
          <input #password type="password" matInput placeholder="{{'core.signin.password' | translate}}"
            formControlName="password" id="password" required>
          <button matSuffix mat-icon-button class="btn-show-password btn btn-primary" type="button"
            aria-label="Mostrar contraseña" (mousedown)="showPass()" (mouseup)="hidePass()">
            <mat-icon>remove_red_eye</mat-icon>
          </button>
        </mat-form-field>

        <div class="error-message" *ngIf="authService.errorLogin">
          {{ authService.errorLogin }}
        </div>

        <div class="actions">
          <button mat-flat-button color="accent" (click)="login()">{{'general.enter' | translate}}</button>
          <span class="text">Si no recuerda su contraseña elija una de las opciones:</span>
          <div class="links">
            <a mat-button class="remember-pass-link"
              (click)="openRememberPasswordDialog('remember');">{{'core.signin.rememberPassword'|translate}}</a>
            <a mat-button class="get-link"
              (click)="openRememberPasswordDialog('link');">{{'core.signin.linkAccess'|translate}}</a>
          </div>
        </div>

      </div>
    </form>
  </main>

</div>